import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% extra de desconto',
  [OfferKindEnum.PercentageOffByProducts]: '{{percentageAmount}}% extra de desconto',
  [OfferKindEnum.AmountOffByProducts]: '{{amount}} extra de desconto',
  [OfferKindEnum.Bogo]: '2 POR 1',
  [OfferKindEnum.BogoHalfPrice]: 'Compra 1 e leva 1 a metade do preço!',
  [OfferKindEnum.FreeItemByProducts]: 'Artigo grátis',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Artigo grátis',
};

export default OfferBadge;
